import styled from "styled-components";
import { Tabs, Menu } from "@mui/material";
import AppBar from "@mui/material/AppBar";

export const Style = styled(AppBar)({
  backgroundColor: "#111f4d !important",
  color: "#000",
  boxShadow: "none !important",
  "& .brand svg": {
    display: "inline-block",
    width: "130px",
    height: "100%",
    marginTop: "3px",
  },
});

export const MenuStyle = styled(Menu)({
  "& .MuiPaper-elevation": {
    backgroundColor: "#041e43 !important",
    color: "#fff"
  },
  "hr": {
    border: "0",
    borderBottom: "1px solid",
    margin: "10px 25px",
    color: "#4c5e78",
  },
  "& .avatar-name": {
    display: "flex",
    flexDirection: "column",
    gap: "0.7rem",
    color: "#fff",
    alignItems: "self-start",
    cursor: "default",
    ".MuiTouchRipple-root": {
      display: "none"
    },
    ":hover": {
      backgroundColor: "unset"
    }
  },
  "& .MuiMenu-list": {
    minWidth: "200px",
    alignItems: "self-start",
  },
  "& .profile p": {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "svg": {
      fontSize: "1.3rem"
    }
  },
  "& .invitation_code": {
    "p": {
      display: "flex",
      alignItems: "center",
      gap: "1rem",
    },
    ".invitation_code-text": {
      display: "inline",
    },
    ".the-code": {
      display: "none",
    },
    "&:hover": {
      ".invitation_code-text": {
        display: "none",
      },
      ".the-code": {
        display: "inline",
      }
    }
  },
  "& .MuiMenuItem-gutters": {
    minHeight: "unset",
  }
})

export const TabsStyle = styled(Tabs)({
  backgroundColor: "#0d1a46",
  borderRadius: "12px",
  "*": {
    color: "#caced3",
    transition: "all 0.3s ease",
  },
  "& .MuiTouchRipple-root": {
    display: "none"
  },
  "& .MuiButtonBase-root": {
    zIndex: "2",
    color: "#caced3",
  },
  "& .Mui-selected": {
    color: "#fff !important",
  },
  "& .MuiTabs-indicator": {
    background: "linear-gradient(130deg, #2043ce, #132a81)",
    height: "100%",
    zIndex: 1,
    borderRadius: "12px",
  }
});
